import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import {
  Perfil,
  PostProfile,
  Profile,
  ProfileResponse,
  PutProfile,
} from '../models/perfil';
import { environment } from '../../../../enviroments/enviroment';

@Injectable({
  providedIn: 'root',
})
export class PerfilService {
  private urlEndPoint = environment.urlEndPoint + '/api/perfil';
  private urlEndPointAdmin = environment.urlEndPoint + '/api/perfil-admin';
  private httpHeaders = new HttpHeaders({ 'Content-type': 'application/json' });
  constructor(private http: HttpClient) {}

  findAll(): Observable<Perfil[]> {
    return this.http.get<Perfil[]>(`${this.urlEndPoint}/all`);
  }

  getAllProfiles(): Observable<Profile[]> {
    return this.http.get<Profile[]>(`${this.urlEndPoint}/all`);
  }

  findAllByPerfil(codigo: string): Observable<Perfil> {
    return this.http.get<Perfil>(`${this.urlEndPoint}?codigo=${codigo}`);
  }

  //Modificar
  create(componente: PostProfile): Observable<ProfileResponse> {
    return this.http.post<ProfileResponse>(
      `${this.urlEndPointAdmin}`,
      componente,
      {
        headers: this.httpHeaders,
      }
    );
  }

  //Modificar
  update(componente: PutProfile): Observable<ProfileResponse> {
    return this.http.put<ProfileResponse>(
      `${this.urlEndPointAdmin}`,
      componente,
      {
        headers: this.httpHeaders,
      }
    );
  }
}
